// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kleine-articles{margin-bottom:2rem}.kleine-articles__title{font-family:Fira Sans Condensed, Rubik, Helvetica, Arial Narrow, Arial, sans-serif;font-weight:700;text-transform:uppercase;line-height:1.5;letter-spacing:-0.015em}.kleine-articles__title a{-webkit-text-decoration-line:underline;text-decoration-line:underline;color:inherit}.kleine-articles__list h2{font-family:Roboto Slab, Georgia, serif;font-size:0.875rem;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
